import script from "./ReceiptMatchingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiptMatchingDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiptMatchingDialog.vue?vue&type=style&index=0&id=5dc38bc0&lang=scss&scoped=true"
import "./ReceiptMatchingDialog.vue?vue&type=style&index=1&id=5dc38bc0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc38bc0"]])

export default __exports__